import { t } from "@lingui/macro";
import * as v from "valibot";
import type { Permission } from "~/models/permission";

export const key = "collaborator.create";

export const permissions: Array<Permission | RegExp> = [
  "Admin.InviteCollaborator",
];

export const Schema = () =>
  v.object({
    labelUid: v.optional(v.string(t`The label ID must be a string.`)),
  });
